import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';

import React, { useCallback, useContext, useMemo } from 'react';
import classnames from 'clsx';
import { FormattedMessage } from 'react-intl';

import { BundleContext } from '../../../bundle-context';
import { BundlePackingSlipDisplayMode } from '../../../constants/product-options';
import { SimpleDropdown } from '../../../../../components/simple-dropdown';
import { useEnableBundleDisplayModeEnum } from '../../../../../feature-flags/hooks/use-enable-bundle-display-mode-enum';
import { Checkbox } from 'ui-components/components/checkbox';

import style from '../../../style.module.less';
import bundleStyle from './style.module.less';
import { messages } from './messages';
import { BundleComponentsTable } from './bundle-component-table';
import { MultiActionButton } from 'ui-components/components/button/multi-action-button';

export const ProductDetailsBundle = () => {
  const { bundlePackingSlipDisplayMode, setBundlePackingSlipDisplayMode, addBundleComponent } = useContext(BundleContext);
  const isDisplayModeEnumEnabled = useEnableBundleDisplayModeEnum();

  const displayModeItems = useMemo(
    () => [
      {
        key: BundlePackingSlipDisplayMode.ChildrenOnly,
        name: <FormattedMessage {...messages.displayModeChildrenOnly} />,
      },
      {
        key: BundlePackingSlipDisplayMode.ParentOnly,
        name: <FormattedMessage {...messages.displayModeParentOnly} />,
      },
      {
        key: BundlePackingSlipDisplayMode.ParentAndChildren,
        name: <FormattedMessage {...messages.displayModeBoth} />,
      },
    ],
    [],
  );

  const shouldShowBundleOnPackingSlip = bundlePackingSlipDisplayMode !== BundlePackingSlipDisplayMode.ChildrenOnly;

  const handleCheckboxChange = useCallback(
    (checked) => {
      setBundlePackingSlipDisplayMode(checked ? BundlePackingSlipDisplayMode.ParentOnly : BundlePackingSlipDisplayMode.ChildrenOnly);
    },
    [setBundlePackingSlipDisplayMode],
  );

  return (
    <>
      <div className={style['shipping-defaults-header-wrapper']}>
        <div className={classnames(style['shipping-defaults-header-text'])}>
          <FormattedMessage {...messages.productBundleComponentsTitle} />
        </div>
      </div>
      <div className={bundleStyle['options-plus-add']}>
        {isDisplayModeEnumEnabled ? (
          <SimpleDropdown
            label={<FormattedMessage {...messages.bundlePackingSlipDisplayModeLabel} />}
            items={displayModeItems}
            selectedItemKey={bundlePackingSlipDisplayMode}
            onItemSelected={setBundlePackingSlipDisplayMode}
          />
        ) : (
          <Checkbox
            checked={shouldShowBundleOnPackingSlip}
            label={<FormattedMessage {...messages.showBundleOnPackingSlip} />}
            onChange={handleCheckboxChange}
          />
        )}
        <MultiActionButton buttonSize='normal' onClick={addBundleComponent} theme='secondary'>
          <div className={style['add-component-button']}>
            <FormattedMessage
              {...messages.productBundleComponentAdd}
              values={{
                icon: <FontAwesomeIcon className={style.icon} icon={faPlus} />,
                span: (chunks) => <span className={style['add-item-button-text']}>{chunks}</span>,
              }}
            />
          </div>
        </MultiActionButton>
      </div>
      <BundleComponentsTable />
    </>
  );
};
